import { render, staticRenderFns } from "./PracticesRequirement.vue?vue&type=template&id=4dad85b4&scoped=true"
import script from "./PracticesRequirement.vue?vue&type=script&lang=ts"
export * from "./PracticesRequirement.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dad85b4",
  null
  
)

export default component.exports